import { store } from '@risingstack/react-easy-state';
import { FieldArrayFieldsProps } from 'redux-form';
import { ProductPosition } from 'framework/modules/searchadmin/models/product';

export const positionsStore = store<{
  fields: FieldArrayFieldsProps<ProductPosition>;
  newPositions: string[];
}>();
